var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "general-wrapper margin-side" },
    [
      _c(
        "div",
        {
          staticClass: "overlay",
          class: { isLoading: _vm.getIsLoading, noDisplay: !_vm.getIsLoading }
        },
        [
          _c(
            "div",
            { staticClass: "spinner-align" },
            [
              _c("Icon", {
                staticClass: "icon-size",
                attrs: { name: "spinner", scale: "5", pulse: "" }
              })
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      !_vm.getIsLoading
        ? _c(
            "div",
            { staticClass: "scheduler-config-wrapper" },
            [
              _c("div", { staticClass: "icon-back-wrapper" }, [
                _c("div", {
                  staticClass: "icon-back",
                  on: {
                    click: function($event) {
                      _vm.back()
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "page-title" }, [
                _c("div", { staticClass: "h2-text" }, [
                  _vm._v("\n        Configure Scheduler\n      ")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "toggle-live toggle-on-off" }, [
                  _c("input", {
                    class: { checked: _vm.configurations.live },
                    attrs: { type: "checkbox", id: "live" }
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      attrs: { for: "live" },
                      on: {
                        click: function($event) {
                          _vm.configurations.live = !_vm.configurations.live
                        }
                      }
                    },
                    [_vm._v("Live")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "text-entry-title align-inline",
                      class: { active: _vm.configurations.live }
                    },
                    [_vm._v("Live")]
                  )
                ])
              ]),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  on: {
                    click: function($event) {
                      _vm.handleOpenSchedulerPreview()
                    }
                  }
                },
                [_vm._v("Preview")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "row margin-top-40px" }, [
                _c(
                  "div",
                  { staticClass: "col-md-4 text-entry-field-wrapper" },
                  [
                    _c("div", { staticClass: "text-entry-title" }, [
                      _vm._v("Scheduler name")
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.configurations.name,
                          expression: "configurations.name"
                        }
                      ],
                      staticClass: "text-input",
                      domProps: { value: _vm.configurations.name },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.configurations,
                            "name",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-8" })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row margin-top-40px" }, [
                _c(
                  "div",
                  { staticClass: "col-md-4 text-entry-field-wrapper" },
                  [
                    _c("div", { staticClass: "text-entry-title" }, [
                      _vm._v("Scheduler URL")
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.configurations.schedulerUrl,
                          expression: "configurations.schedulerUrl"
                        }
                      ],
                      staticClass: "text-input",
                      domProps: { value: _vm.configurations.schedulerUrl },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.configurations,
                            "schedulerUrl",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-2 text-entry-field-wrapper" },
                  [
                    _c("div", { staticClass: "text-entry-title" }, [
                      _vm._v("URL Hyperlink Color")
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.configurations.urlHyperlinkColor,
                          expression: "configurations.urlHyperlinkColor"
                        }
                      ],
                      staticClass: "text-input",
                      domProps: { value: _vm.configurations.urlHyperlinkColor },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.configurations,
                            "urlHyperlinkColor",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-2 text-entry-field-wrapper" },
                  [
                    _c("div", { staticClass: "text-entry-title" }, [
                      _vm._v("Branded URL")
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.configurations.brandedURL,
                          expression: "configurations.brandedURL"
                        },
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required|url:require_protocol",
                          expression: "'required|url:require_protocol'"
                        }
                      ],
                      staticClass: "text-input",
                      attrs: { name: "brandedURL" },
                      domProps: { value: _vm.configurations.brandedURL },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.configurations,
                            "brandedURL",
                            $event.target.value
                          )
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "branded-url-error" }, [
                      _vm.errors.has("brandedURL")
                        ? _c("div", { staticClass: "alert-icon-red-error" })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "error-text-color" }, [
                        _vm._v(_vm._s(_vm.errors.first("brandedURL")))
                      ])
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-4" })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row margin-top-40px" }, [
                _c(
                  "div",
                  { staticClass: "col-md-4 text-entry-field-wrapper" },
                  [
                    _c("div", { staticClass: "text-entry-title" }, [
                      _vm._v("Brand Name")
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.configurations.brandName,
                          expression: "configurations.brandName"
                        }
                      ],
                      staticClass: "text-input",
                      domProps: { value: _vm.configurations.brandName },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.configurations,
                            "brandName",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-4 text-entry-field-wrapper" },
                  [
                    _c("div", { staticClass: "text-entry-title" }, [
                      _vm._v("Survey Biometric Result URL")
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.configurations.surveyBiometricResultUrl,
                          expression: "configurations.surveyBiometricResultUrl"
                        }
                      ],
                      staticClass: "text-input",
                      domProps: {
                        value: _vm.configurations.surveyBiometricResultUrl
                      },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.configurations,
                            "surveyBiometricResultUrl",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-4 text-entry-field-wrapper" },
                  [
                    _c("div", { staticClass: "text-entry-title" }, [
                      _vm._v("ShiftBoard Lead WorkGroup")
                    ]),
                    _vm._v(" "),
                    _c("multiselect", {
                      staticClass: "multiple-select-work-group",
                      attrs: {
                        options: _vm.allWorkGroups,
                        placeholder: "Choose WorkGroup",
                        label: "name",
                        openDirection: "below",
                        multiple: false,
                        "close-on-select": true,
                        "hide-selected": true,
                        "track-by": "id",
                        "allow-empty": false,
                        "show-labels": false,
                        disabled: false
                      },
                      on: { select: _vm.dropdownItemClick },
                      model: {
                        value: _vm.dropdowntitle,
                        callback: function($$v) {
                          _vm.dropdowntitle = $$v
                        },
                        expression: "dropdowntitle"
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "text-entry-title" }, [
                      _vm._v("ShiftBoard Screener WorkGroup")
                    ]),
                    _vm._v(" "),
                    _c("multiselect", {
                      staticClass: "multiple-select-work-group",
                      attrs: {
                        options: _vm.allWorkGroups,
                        placeholder: "Choose Screener WorkGroup",
                        label: "name",
                        openDirection: "below",
                        multiple: false,
                        "close-on-select": true,
                        "hide-selected": true,
                        "track-by": "id",
                        "allow-empty": false,
                        "show-labels": false,
                        disabled: false
                      },
                      on: { select: _vm.screenerDropdownItemClick },
                      model: {
                        value: _vm.screenerDropdowntitle,
                        callback: function($$v) {
                          _vm.screenerDropdowntitle = $$v
                        },
                        expression: "screenerDropdowntitle"
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "text-entry-title" }, [
                      _vm._v("ShiftBoard Phlebotomist WorkGroup")
                    ]),
                    _vm._v(" "),
                    _c("multiselect", {
                      staticClass: "multiple-select-work-group",
                      attrs: {
                        options: _vm.allWorkGroups,
                        placeholder: "Choose Phlebotomist WorkGroup",
                        label: "name",
                        openDirection: "below",
                        multiple: false,
                        "close-on-select": true,
                        "hide-selected": true,
                        "track-by": "id",
                        "allow-empty": false,
                        "show-labels": false,
                        disabled: false
                      },
                      on: { select: _vm.phlebotomistDropdownItemClick },
                      model: {
                        value: _vm.phlebotomistDropdowntitle,
                        callback: function($$v) {
                          _vm.phlebotomistDropdowntitle = $$v
                        },
                        expression: "phlebotomistDropdowntitle"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "margin-top-24px toggle-limeade-sso-container" },
                [
                  _c("div", { staticClass: "toggle-on-off" }, [
                    _c("input", {
                      class: {
                        checked: _vm.configurations.allowWithoutLimeade
                      },
                      attrs: { type: "checkbox", id: "without_limeade_login" }
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        attrs: { for: "without_limeade_login" },
                        on: {
                          click: function($event) {
                            _vm.configurations.allowWithoutLimeade = !_vm
                              .configurations.allowWithoutLimeade
                          }
                        }
                      },
                      [_vm._v("Toggle")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "text-entry-title align-inline",
                        class: {
                          active: _vm.configurations.allowWithoutLimeade
                        }
                      },
                      [_vm._v("Allow walk-in checkin\n        ")]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "toggle-on-off " }, [
                    _c("input", {
                      class: { checked: _vm.configurations.allowBookFluShot },
                      attrs: { type: "checkbox", id: "allow_spouse" }
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        attrs: { for: "allow_spouse" },
                        on: {
                          click: function($event) {
                            _vm.configurations.allowBookFluShot = !_vm
                              .configurations.allowBookFluShot
                          }
                        }
                      },
                      [_vm._v("Toggle")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "text-entry-title align-inline",
                        class: { active: _vm.configurations.allowBookFluShot }
                      },
                      [_vm._v("Allow flu shot appointment\n        ")]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "toggle-on-off" }, [
                    _c("input", {
                      class: {
                        checked: _vm.configurations.zendeskConfiguration
                      },
                      attrs: { type: "checkbox", id: "is_display_zendesk" }
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        attrs: { for: "is_display_zendesk" },
                        on: {
                          click: function($event) {
                            _vm.configurations.zendeskConfiguration = !_vm
                              .configurations.zendeskConfiguration
                          }
                        }
                      },
                      [_vm._v("Toggle")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "text-entry-title align-inline",
                        class: {
                          active: _vm.configurations.zendeskConfiguration
                        }
                      },
                      [_vm._v("Allow ZenDesk\n        ")]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "toggle-on-off" }, [
                    _c("input", {
                      class: {
                        checked: _vm.configurations.multipleScreeningsPerYear
                      },
                      attrs: { type: "checkbox", id: "is_display_program_year" }
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        attrs: { for: "is_display_program_year" },
                        on: {
                          click: function($event) {
                            _vm.configurations.multipleScreeningsPerYear = !_vm
                              .configurations.multipleScreeningsPerYear
                          }
                        }
                      },
                      [_vm._v("Toggle")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "text-entry-title align-inline",
                        class: {
                          active: _vm.configurations.multipleScreeningsPerYear
                        }
                      },
                      [_vm._v("Allow multiple screenings per year\n        ")]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "toggle-on-off" }, [
                    _c("input", {
                      class: { checked: _vm.configurations.fluShotOnly },
                      attrs: { type: "checkbox", id: "flu_shot_only" }
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        attrs: { for: "flu_shot_only" },
                        on: {
                          click: function($event) {
                            _vm.configurations.fluShotOnly = !_vm.configurations
                              .fluShotOnly
                          }
                        }
                      },
                      [_vm._v("Toggle")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "text-entry-title align-inline",
                        class: { active: _vm.configurations.fluShotOnly }
                      },
                      [_vm._v("Allow flu shot only\n        ")]
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "row margin-top-40px" }, [
                _c("div", { staticClass: "col-md-4" }, [
                  _c("div", { staticClass: "toggle-on-off" }, [
                    _c("input", {
                      class: { checked: _vm.configurations.allowBookForSpouse },
                      attrs: { type: "checkbox", id: "allow_flu_shot" }
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        attrs: { for: "allow_flu_shot" },
                        on: {
                          click: function($event) {
                            _vm.configurations.allowBookForSpouse = !_vm
                              .configurations.allowBookForSpouse
                          }
                        }
                      },
                      [_vm._v("Toggle")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "text-entry-title align-inline",
                        class: { active: _vm.configurations.allowBookForSpouse }
                      },
                      [_vm._v("\n            Spouse appointment\n          ")]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "text-entry-field-wrapper" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "text-entry-title margin-top-15px display-flex-end",
                        class: {
                          "opacity-06": !_vm.configurations.allowBookForSpouse
                        }
                      },
                      [
                        _c("div", [_vm._v("Spouse Label")]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "display-space-between",
                            class: {
                              noDisplay: !_vm.configurations.allowBookForSpouse
                            }
                          },
                          [
                            _vm.errors.has("spouse")
                              ? _c("div", {
                                  staticClass: "alert-icon-red-error"
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "error-text-color" }, [
                              _vm._v(_vm._s(_vm.errors.first("Spouse")))
                            ])
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.configurations.spouseLabel,
                          expression: "configurations.spouseLabel"
                        },
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'"
                        }
                      ],
                      staticClass: "text-input",
                      class: {
                        "opacity-06": !_vm.configurations.allowBookForSpouse
                      },
                      attrs: {
                        disabled: !_vm.configurations.allowBookForSpouse,
                        name: "Spouse"
                      },
                      domProps: { value: _vm.configurations.spouseLabel },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.configurations,
                            "spouseLabel",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-8" })
              ]),
              _vm._v(" "),
              _c("div", {
                staticClass: "margin-top-40px toggle-limeade-sso-container"
              }),
              _vm._v(" "),
              _c("div", { staticClass: "row margin-top-40px" }, [
                _c(
                  "div",
                  { staticClass: "col-md-4 text-entry-field-wrapper" },
                  [
                    _c("div", { staticClass: "text-entry-title" }, [
                      _vm._v("Landing Page Top Text")
                    ]),
                    _vm._v(" "),
                    _c("vue-ckeditor", {
                      attrs: { config: _vm.config },
                      model: {
                        value: _vm.configurations.landingTopText,
                        callback: function($$v) {
                          _vm.$set(_vm.configurations, "landingTopText", $$v)
                        },
                        expression: "configurations.landingTopText"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-4 text-entry-field-wrapper" },
                  [
                    _c("div", { staticClass: "text-entry-title" }, [
                      _vm._v("Landing Page Bottom Text")
                    ]),
                    _vm._v(" "),
                    _c("vue-ckeditor", {
                      attrs: { config: _vm.config },
                      model: {
                        value: _vm.configurations.landingBottomText,
                        callback: function($$v) {
                          _vm.$set(_vm.configurations, "landingBottomText", $$v)
                        },
                        expression: "configurations.landingBottomText"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-4 text-entry-field-wrapper" },
                  [
                    _c("div", { staticClass: "text-entry-title" }, [
                      _vm._v("Thank you page text")
                    ]),
                    _vm._v(" "),
                    _c("vue-ckeditor", {
                      attrs: { config: _vm.config },
                      model: {
                        value: _vm.configurations.landingThankYouText,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.configurations,
                            "landingThankYouText",
                            $$v
                          )
                        },
                        expression: "configurations.landingThankYouText"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row margin-top-40px" }, [
                _c("div", { staticClass: "col-md-4" }, [
                  _c("div", { staticClass: "toggle-on-off" }, [
                    _c("input", {
                      class: { checked: _vm.configurations.hpsf },
                      attrs: { type: "checkbox", id: "hpsf" }
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        attrs: { for: "hpsf" },
                        on: {
                          click: function($event) {
                            _vm.configurations.hpsf = !_vm.configurations.hpsf
                          }
                        }
                      },
                      [_vm._v("Toggle")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "hpsf-labcorp-htk align-inline padding-left-8px",
                        class: { active: _vm.configurations.hpsf }
                      },
                      [_vm._v("HPSF\n          ")]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "text-entry-field-wrapper" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "text-entry-title margin-top-15px display-flex-end",
                        class: { "opacity-06": !_vm.configurations.hpsf }
                      },
                      [
                        _c("div", [_vm._v("HPSF URL")]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "display-space-between",
                            class: { noDisplay: !_vm.configurations.hpsf }
                          },
                          [
                            _vm.errors.has("hpsf")
                              ? _c("div", {
                                  staticClass: "alert-icon-red-error"
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "error-text-color" }, [
                              _vm._v(_vm._s(_vm.errors.first("hpsf")))
                            ])
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.configurations.hpsfUrl,
                          expression: "configurations.hpsfUrl"
                        },
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required|url:require_protocol",
                          expression: "'required|url:require_protocol'"
                        }
                      ],
                      staticClass: "text-input",
                      class: { "opacity-06": !_vm.configurations.hpsf },
                      attrs: {
                        disabled: !_vm.configurations.hpsf,
                        name: "hpsf"
                      },
                      domProps: { value: _vm.configurations.hpsfUrl },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.configurations,
                            "hpsfUrl",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-4" }, [
                  _c("div", { staticClass: "toggle-on-off" }, [
                    _c("input", {
                      class: { checked: _vm.configurations.labCorp },
                      attrs: { type: "checkbox", id: "labcorp" }
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        attrs: { for: "labcorp" },
                        on: {
                          click: function($event) {
                            _vm.configurations.labCorp = !_vm.configurations
                              .labCorp
                          }
                        }
                      },
                      [_vm._v("Toggle")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "hpsf-labcorp-htk align-inline padding-left-8px",
                        class: { active: _vm.configurations.labCorp }
                      },
                      [_vm._v("\n            Labcorp\n          ")]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "text-entry-field-wrapper" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "text-entry-title margin-top-15px display-flex-end",
                        class: { "opacity-06": !_vm.configurations.labCorp }
                      },
                      [
                        _c("div", [_vm._v("Labcorp URL")]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "display-space-between",
                            class: { noDisplay: !_vm.configurations.labCorp }
                          },
                          [
                            _vm.errors.has("labcorp")
                              ? _c("div", {
                                  staticClass: "alert-icon-red-error"
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "error-text-color" }, [
                              _vm._v(_vm._s(_vm.errors.first("labcorp")))
                            ])
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.configurations.labCorpUrl,
                          expression: "configurations.labCorpUrl"
                        },
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required|url:require_protocol",
                          expression: "'required|url:require_protocol'"
                        }
                      ],
                      staticClass: "text-input",
                      class: { "opacity-06": !_vm.configurations.labCorp },
                      attrs: {
                        disabled: !_vm.configurations.labCorp,
                        name: "labcorp"
                      },
                      domProps: { value: _vm.configurations.labCorpUrl },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.configurations,
                            "labCorpUrl",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-4" }, [
                  _c("div", { staticClass: "toggle-on-off" }, [
                    _c("input", {
                      class: { checked: _vm.configurations.htk },
                      attrs: { type: "checkbox", id: "htk" }
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        attrs: { for: "htk" },
                        on: {
                          click: function($event) {
                            _vm.configurations.htk = !_vm.configurations.htk
                          }
                        }
                      },
                      [_vm._v("Toggle")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "hpsf-labcorp-htk align-inline padding-left-8px",
                        class: { active: _vm.configurations.htk }
                      },
                      [_vm._v("HTK\n          ")]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "text-entry-field-wrapper" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "text-entry-title margin-top-15px display-flex-end",
                        class: { "opacity-06": !_vm.configurations.htk }
                      },
                      [
                        _c("div", [_vm._v("HTK URL")]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "display-space-between",
                            class: { noDisplay: !_vm.configurations.htk }
                          },
                          [
                            _vm.errors.has("htk")
                              ? _c("div", {
                                  staticClass: "alert-icon-red-error"
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "error-text-color" }, [
                              _vm._v(_vm._s(_vm.errors.first("htk")))
                            ])
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.configurations.htkUrl,
                          expression: "configurations.htkUrl"
                        },
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required|url:require_protocol",
                          expression: "'required|url:require_protocol'"
                        }
                      ],
                      staticClass: "text-input",
                      class: { "opacity-06": !_vm.configurations.htk },
                      attrs: { disabled: !_vm.configurations.htk, name: "htk" },
                      domProps: { value: _vm.configurations.htkUrl },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.configurations,
                            "htkUrl",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "margin-top-40px" }, [
                _c("div", { staticClass: "logo" }, [
                  _vm._v("Logo "),
                  _vm.isUsedBingMap()
                    ? _c("span", [_vm._v("(Maximum size is 300KB)")])
                    : _vm._e()
                ])
              ]),
              _vm._v(" "),
              _vm.isUsedBingMap()
                ? _c("div", { staticClass: "margin-top-15px" }, [
                    _vm.imageData.length > 0
                      ? _c("div", { staticClass: "image-preview" }, [
                          _c("img", {
                            staticClass: "preview",
                            attrs: { src: _vm.imageData }
                          })
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "upload-button-wrapper" }, [
                      _c("span", { staticClass: "upload-button-text" }, [
                        _vm._v("upload")
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        ref: "logo",
                        staticClass: "custom-file-input upload-avatar",
                        attrs: {
                          type: "file",
                          name: "imageFile",
                          id: "file",
                          accept: "image/*"
                        },
                        on: { change: _vm.previewImage }
                      })
                    ]),
                    _vm._v(" "),
                    _vm.imageData.length > 0
                      ? _c(
                          "button",
                          {
                            staticClass: "ap-btn primary remove-button",
                            on: {
                              click: function($event) {
                                _vm.removeImage()
                              }
                            }
                          },
                          [_vm._v("remove")]
                        )
                      : _vm._e()
                  ])
                : _vm._e(),
              _vm._v(" "),
              !_vm.isUsedBingMap()
                ? _c("div", { staticClass: "margin-top-15px" }, [
                    _vm.configurations &&
                    _vm.configurations.logoUrl &&
                    _vm.configurations.logoUrl.length > 0
                      ? _c("div", { staticClass: "image-preview" }, [
                          _c("img", {
                            staticClass: "preview",
                            attrs: { src: _vm.configurations.logoUrl }
                          })
                        ])
                      : _vm._e()
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "event-list" }, [
                _c("div", { staticClass: "title" }, [_vm._v("events")]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "row list-event" },
                  _vm._l(_vm.eventSchedulerList, function(event) {
                    return _c(
                      "div",
                      { key: event, staticClass: "col-md-4 list-event-item" },
                      [
                        _c("div", { staticClass: "event-name" }, [
                          _vm._v(_vm._s(event.eventName))
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "toggle-on-off align-inline padding-left-19px"
                          },
                          [
                            _c("input", {
                              class: { checked: event.isOnlineScheduler },
                              attrs: {
                                type: "checkbox",
                                id: "event_" + event.id
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                attrs: { for: "event_" + event.id },
                                on: {
                                  click: function($event) {
                                    event.isOnlineScheduler = !event.isOnlineScheduler
                                  }
                                }
                              },
                              [_vm._v("Toggle")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "text-entry-title align-inline padding-left-3px",
                                class: { active: event.isOnlineScheduler }
                              },
                              [_vm._v("Online scheduler\n            ")]
                            )
                          ]
                        )
                      ]
                    )
                  })
                )
              ]),
              _vm._v(" "),
              _vm._m(0),
              _vm._v(" "),
              _vm.configEmail.emailTags.length
                ? _c("div", { staticClass: "row margin-top-5px" }, [
                    _c(
                      "div",
                      { staticClass: "col-md-6 text-entry-field-wrapper" },
                      [
                        _c("div", { staticClass: "email-head-text" }, [
                          _vm._v("Confirmation Email")
                        ]),
                        _vm._v(" "),
                        _c("vue-ckeditor", {
                          attrs: { config: _vm.configEmail },
                          model: {
                            value:
                              _vm.configurations.confirmationEmailTemplate.body,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.configurations.confirmationEmailTemplate,
                                "body",
                                $$v
                              )
                            },
                            expression:
                              "configurations.confirmationEmailTemplate.body"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-6 text-entry-field-wrapper" },
                      [
                        _c("div", { staticClass: "email-head-text" }, [
                          _vm._v("Confirmation Email for Spouse")
                        ]),
                        _vm._v(" "),
                        _c("vue-ckeditor", {
                          attrs: { config: _vm.configEmail },
                          model: {
                            value:
                              _vm.configurations.confirmationSpouseEmailTemplate
                                .body,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.configurations
                                  .confirmationSpouseEmailTemplate,
                                "body",
                                $$v
                              )
                            },
                            expression:
                              "configurations.confirmationSpouseEmailTemplate.body"
                          }
                        })
                      ],
                      1
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.configEmail.emailTags.length
                ? _c("div", { staticClass: "row margin-top-5px" }, [
                    _c(
                      "div",
                      { staticClass: "col-md-6 text-entry-field-wrapper" },
                      [
                        _c("div", { staticClass: "email-head-text" }, [
                          _vm._v("Cancellation Email To Participant")
                        ]),
                        _vm._v(" "),
                        _c("vue-ckeditor", {
                          attrs: { config: _vm.configEmail },
                          model: {
                            value:
                              _vm.configurations.cancellationEmailTemplate.body,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.configurations.cancellationEmailTemplate,
                                "body",
                                $$v
                              )
                            },
                            expression:
                              "configurations.cancellationEmailTemplate.body"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-6 text-entry-field-wrapper" },
                      [
                        _c("div", { staticClass: "email-head-text" }, [
                          _vm._v("Cancellation Email To Spouse")
                        ]),
                        _vm._v(" "),
                        _c("vue-ckeditor", {
                          attrs: { config: _vm.configEmail },
                          model: {
                            value:
                              _vm.configurations.cancellationSpouseEmailTemplate
                                .body,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.configurations
                                  .cancellationSpouseEmailTemplate,
                                "body",
                                $$v
                              )
                            },
                            expression:
                              "configurations.cancellationSpouseEmailTemplate.body"
                          }
                        })
                      ],
                      1
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.configEmail.emailTags.length
                ? _c("div", { staticClass: "row margin-top-5px" }, [
                    _c(
                      "div",
                      { staticClass: "col-md-6 text-entry-field-wrapper" },
                      [
                        _c("div", { staticClass: "email-head-text" }, [
                          _vm._v("Reminder Email To Participant")
                        ]),
                        _vm._v(" "),
                        _c("vue-ckeditor", {
                          attrs: { config: _vm.configEmail },
                          model: {
                            value:
                              _vm.configurations.reminderEmailTemplate.body,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.configurations.reminderEmailTemplate,
                                "body",
                                $$v
                              )
                            },
                            expression:
                              "configurations.reminderEmailTemplate.body"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-6 text-entry-field-wrapper" },
                      [
                        _c("div", { staticClass: "email-head-text" }, [
                          _vm._v("Reminder Email To Spouse")
                        ]),
                        _vm._v(" "),
                        _c("vue-ckeditor", {
                          attrs: { config: _vm.configEmail },
                          model: {
                            value:
                              _vm.configurations.reminderSpouseEmailTemplate
                                .body,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.configurations.reminderSpouseEmailTemplate,
                                "body",
                                $$v
                              )
                            },
                            expression:
                              "configurations.reminderSpouseEmailTemplate.body"
                          }
                        })
                      ],
                      1
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.configEmail.emailTags.length
                ? _c("div", { staticClass: "row margin-top-5px" }, [
                    _c(
                      "div",
                      { staticClass: "col-md-6 text-entry-field-wrapper" },
                      [
                        _c("div", { staticClass: "email-head-text" }, [
                          _vm._v("Biometric Survey Email")
                        ]),
                        _vm._v(" "),
                        _c("vue-ckeditor", {
                          attrs: { config: _vm.configEmail },
                          model: {
                            value:
                              _vm.configurations.biometricResultEmailTemplate
                                .body,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.configurations.biometricResultEmailTemplate,
                                "body",
                                $$v
                              )
                            },
                            expression:
                              "configurations.biometricResultEmailTemplate.body"
                          }
                        })
                      ],
                      1
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "margin-top-44px group-btn" }, [
                _c(
                  "button",
                  {
                    staticClass: "ap-btn secondary",
                    on: {
                      click: function($event) {
                        _vm.back()
                      }
                    }
                  },
                  [_vm._v("\n        cancel\n      ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "ap-btn primary",
                    class: { "opacity-04": _vm.isLoading },
                    attrs: { disabled: _vm.isLoading },
                    on: {
                      click: function($event) {
                        _vm.saveConfigurations()
                      }
                    }
                  },
                  [_vm._v("Save")]
                )
              ])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("PatientDetailModal"),
      _vm._v(" "),
      _c("SchedulerPreview")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "event-list" }, [
      _c("div", { staticClass: "title" }, [_vm._v("Participant Emails")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3d7700ad", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d7700ad","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/schedulerConfig/SchedulerConfiguration.vue
// module id = 1804
// module chunks = 1